import { useEffect, useState } from "react";
import AdminHeader from "../../components/layout/AdminHeader";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X } from "lucide-react";

export default function AdminMedia() {
  const [list, setList] = useState([]);
  const [adding, setAdding] = useState(false);
  const [n, setN] = useState({ filename: "", url: "", kind: "image", tags: [] });
  const load = async () => { const { data } = await api.get("/media"); setList(data); };
  useEffect(() => { load(); }, []);
  const add = async () => {
    if (!n.filename || !n.url) return;
    try { const { data } = await api.post("/media", n);
      toast.success(data.duplicate ? "Existing asset reused" : "Added");
      setAdding(false); setN({ filename: "", url: "", kind: "image", tags: [] }); load();
    } catch { toast.error("Failed"); }
  };
  const del = async (m) => { if (!window.confirm(`Delete "${m.filename}"?`)) return; await api.delete(`/media/${m.id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="page-admin-media">
      <AdminHeader breadcrumb="Knowledge" title="Media Library"
        subtitle="Centralized asset registry — images, PDFs, videos. Deduplicates by URL."
        actions={<button onClick={() => setAdding(true)} className="btn-gold" data-testid="media-new"><Plus className="h-3.5 w-3.5" /> Register asset</button>} />
      <div className="p-8 space-y-6">
        {adding && (
          <div className="admin-card space-y-3">
            <input className="admin-input" placeholder="Filename" value={n.filename} onChange={(e) => setN({ ...n, filename: e.target.value })} data-testid="media-filename" />
            <input className="admin-input" placeholder="URL (paste asset URL)" value={n.url} onChange={(e) => setN({ ...n, url: e.target.value })} data-testid="media-url" />
            <select className="admin-select" value={n.kind} onChange={(e) => setN({ ...n, kind: e.target.value })}><option>image</option><option>pdf</option><option>video</option><option>doc</option></select>
            <div className="flex gap-2"><button onClick={add} className="btn-espresso" data-testid="media-add">Add</button><button onClick={() => setAdding(false)} className="btn-ghost-espresso">Cancel</button></div>
          </div>
        )}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {list.map((m) => (
            <div key={m.id} className="card-editorial p-3 group" data-testid={`media-item-${m.id}`}>
              <div className="aspect-square overflow-hidden rounded bg-altura-beige">
                {m.kind === "image" ? <img src={m.url} alt={m.filename} className="h-full w-full object-cover" /> :
                  <div className="flex h-full w-full items-center justify-center text-altura-espresso font-mono text-xs uppercase">{m.kind}</div>}
              </div>
              <div className="mt-2 text-xs text-altura-espresso truncate">{m.filename}</div>
              <div className="mt-1 flex items-center justify-between text-[10px] text-altura-charcoal/50">
                <span className="uppercase">{m.kind}</span>
                <button onClick={() => del(m)} className="opacity-0 group-hover:opacity-100 hover:text-altura-burgundy transition"><Trash2 className="h-3.5 w-3.5" /></button>
              </div>
            </div>
          ))}
          {list.length === 0 && <div className="col-span-full text-center py-16 text-altura-charcoal/50">No assets registered yet.</div>}
        </div>
      </div>
    </div>
  );
}
